<template>
  <generic-error
    :title="errorDetails.title"
    button-value="Contact Customer Success"
    button-href="https://support.sittercity.com/hc/en-us/requests/new"
  >
    {{ errorDetails.body }}
  </generic-error>
</template>

<script lang="ts">
import GenericError from '@/components/generic_error/GenericError.vue';

export default {
  name: 'RatingApiError',
  components: { GenericError },
  props: {
    ratingError: {
      type: String,
      default: '',
    },
    sitterName: {
      type: String,
      default: '',
    },
  },
  computed: {
    errorDetails() {
      if (this.ratingError === 'duplicate_review') {
        return {
          title: `You have already left a review for ${this.sitterName ? this.sitterName : 'this sitter'}`,
          body: "You can't leave another review. If you would like to edit your original review or believe this is a mistake, please contact customer success.",
        };
      }

      return {
        title: 'Something went wrong',
        body: `Your rating couldn't be submitted. Refresh the page to try again or contact customer success if the issue continues.`,
      };
    },
  },
};
</script>
